const getDefaultState = () => {
  return {
    sounds: [
      {id: 0, title: 'No Sound', fileName: ''}, // no sound
      {id: 1, title: 'Beyond Doubt', fileName: '01_beyond-doubt.mp3'}, // https://notificationsounds.com/notification-sounds/beyond-doubt-580
      {id: 2, title: 'Ding', fileName: '02_ding.mp3'}, // https://www.freesoundslibrary.com/ding-sound-effect/
      {id: 3, title: 'Done For You', fileName: '03_done-for-you.mp3'}, // https://notificationsounds.com/notification-sounds/done-for-you-612
      {id: 4, title: 'For Sure', fileName: '04_for-sure.mp3'}, // https://notificationsounds.com/notification-sounds/for-sure-576
      {id: 5, title: 'Hollow', fileName: '05_hollow.mp3'}, // https://notificationsounds.com/sound-effects/hollow-582
      {id: 6, title: 'Juntos', fileName: '06_juntos.mp3'}, // https://notificationsounds.com/message-tones/juntos-607
      {id: 7, title: 'Maybe One Day', fileName: '07_maybe-one-day.mp3'}, // https://notificationsounds.com/notification-sounds/maybe-one-day-584
      {id: 8, title: 'Percussion Sound', fileName: '08_percussion-sound.mp3'}, // https://notificationsounds.com/message-tones/percussion-sound-614
      {id: 9, title: 'Point Blank', fileName: '09_point-blank.mp3'}, // https://notificationsounds.com/notification-sounds/point-blank-589
      {id: 10, title: 'Swiftly', fileName: '10_swiftly.mp3'}, // https://notificationsounds.com/notification-sounds/swiftly-610
      {id: 11, title: 'Time Is Now', fileName: '11_time-is-now.mp3'}, // https://notificationsounds.com/notification-sounds/time-is-now-585
      {id: 12, title: 'La cucaracha', fileName: '12_la_cucaracha_horn.mp3'}, 
      {id: 13, title: 'Deducion', fileName: '13_samsung_s10_deducion.mp3'} 
    ]
  }
}

// const state = getDefaultState()

const module = {
  namespaced: true,
  state: {
    sounds: [
      {id: 0, title: 'No Sound', fileName: ''}, // no sound
      {id: 1, title: 'Beyond Doubt', fileName: '01_beyond-doubt.mp3'}, // https://notificationsounds.com/notification-sounds/beyond-doubt-580
      {id: 2, title: 'Ding', fileName: '02_ding.mp3'}, // https://www.freesoundslibrary.com/ding-sound-effect/
      {id: 3, title: 'Done For You', fileName: '03_done-for-you.mp3'}, // https://notificationsounds.com/notification-sounds/done-for-you-612
      {id: 4, title: 'For Sure', fileName: '04_for-sure.mp3'}, // https://notificationsounds.com/notification-sounds/for-sure-576
      {id: 5, title: 'Hollow', fileName: '05_hollow.mp3'}, // https://notificationsounds.com/sound-effects/hollow-582
      {id: 6, title: 'Juntos', fileName: '06_juntos.mp3'}, // https://notificationsounds.com/message-tones/juntos-607
      {id: 7, title: 'Maybe One Day', fileName: '07_maybe-one-day.mp3'}, // https://notificationsounds.com/notification-sounds/maybe-one-day-584
      {id: 8, title: 'Percussion Sound', fileName: '08_percussion-sound.mp3'}, // https://notificationsounds.com/message-tones/percussion-sound-614
      {id: 9, title: 'Point Blank', fileName: '09_point-blank.mp3'}, // https://notificationsounds.com/notification-sounds/point-blank-589
      {id: 10, title: 'Swiftly', fileName: '10_swiftly.mp3'}, // https://notificationsounds.com/notification-sounds/swiftly-610
      {id: 11, title: 'Time Is Now', fileName: '11_time-is-now.mp3'}, // https://notificationsounds.com/notification-sounds/time-is-now-585
      {id: 12, title: 'La cucaracha', fileName: '12_la_cucaracha_horn.mp3'}, 
      {id: 13, title: 'Deducion', fileName: '13_samsung_s10_deducion.mp3'} 
    ]
  },
  mutations: {
    addSound (state, data) {
      state.sounds.push(data)
    },
    deleteAll (state) {
      state.sounds = []
    },
    delete (state, data) {
      let index = state.sounds.indexOf(data)
      if (index !== -1) {
        state.sounds.splice(index, 1)
      }
    },
    RESET_STORE: (state) => {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    addMessage ({ commit }, sound) {
      commit('addSound', sound)
    },
    deleteAll ({commit}) {
      commit('deleteAll')
    },
    deleteSound ({commit}, sound) {
      commit('delete', sound)
    }
  }
}

export default module
